<template>
  <div>
    <div class="row" v-if="showGrid">
      <div class="col-md-12">
        <aron-table @selected="selected" uploadEndpoint="/uploadFile" endPoint="inventories"
          :filterEndpoint="filterEndpoint" key="inventories" :formType="formType"></aron-table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">

        <viewDetails @close="showGrid = true">
        </viewDetails>

      </div>
    </div>
  </div>
</template>

<script>
import AronTable from "@/components/aron/table/inventory.vue";
import viewDetails from "./viewDetails.vue";
//register vieDetails component

export default {
  components: {
    AronTable,
    viewDetails
  },
  computed: {
    filterEndpoint() {
      return "search_inventories";
    }
  },
  data() {
    return { showGrid: true, route: this.$route.params.endPoint, formType: "sidebarRightSide" };
  },
  methods: {
    selected(data) {
      this.showGrid = false;
      console.log(data);
    }
  }
};
</script>
